// extracted by mini-css-extract-plugin
export default {"target_product":"I7","retake":"J7","product_info":"K7","icon":"L7","target_image":"M7","background":"N7","product_info_desktop":"O7","info":"P7","title":"Q7","benefits":"R7","benefit":"S7","accordeon_wrapper":"T7","ingredients_wrapper":"U7","info_wrapper":"V7","product_wrapper":"W7"};
    if(module.hot) {
      // 1743628931284
      var cssReload = require("../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  